var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplaceCard = function SvgReplaceCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.398 2.5 1.939 1.939H2.5V16.07h1.551v1.94H2.5a1.939 1.939 0 0 1-1.939-1.94V4.44A1.939 1.939 0 0 1 2.5 2.5h15.898ZM4.051 18.01v1.551c0 1.07.87 1.939 1.939 1.939H21.5a1.94 1.94 0 0 0 1.939-1.939V7.93a1.94 1.94 0 0 0-1.939-1.94H5.99A1.94 1.94 0 0 0 4.05 7.93v8.142h4.071v-1.938L12 17.04l-3.878 2.908V18.01H4.051Zm9.628.066c.455.454 1.071.71 1.714.71a2.394 2.394 0 0 0 1.454-.497 2.41 2.41 0 0 1-.97-1.927c0-.79.384-1.485.97-1.927a2.394 2.394 0 0 0-1.454-.496 2.424 2.424 0 0 0-1.714 4.137Zm3.878 0a2.424 2.424 0 1 0 3.427-3.428 2.424 2.424 0 0 0-3.427 3.428Z",
    fill: "#666"
  })));
};
export default SvgReplaceCard;